import "./style.css";
// import "@nextgis/ol-map-adapter/lib/ol-map-adapter.css";

import { createRoot } from "react-dom/client";

import { App } from "./App";
import { updateConfig } from "./rskom/config";

const app = document.querySelector<HTMLDivElement>("#app");

if (!app) {
  throw new Error("App is not initialized");
}

try {
  const resp = await fetch("/api/settings", { method: "GET" });
  const config = await resp.json();
  updateConfig(config);
} catch {
  //
}

createRoot(app).render(<App />);
